import { Fragment } from "react";
import { DateTime } from "luxon";
import { t } from "i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";

import ColumnText from "../molecules/ColumnText";
import ColumnDate from "../molecules/ColumnDate";
import { Empty } from "./Empty";

type optionsFestivosProps = {
  id: number;
  description: string;
  date: string;
  timeStart: string;
  timeEnd: string;
  type: string;
};

export type TableListFestivosProps = {
  optionsFestivos: optionsFestivosProps[];
  onDelete: (holiday: any) => void;
  onEdit: (holiday: any) => void;
  openModal: () => void;
};

const TableListFestivos: React.FC<TableListFestivosProps> = ({
  optionsFestivos = [],
  openModal,
  onDelete,
  onEdit,
}) => {
  return (
    <div className="">
      <div className="border-b border-gray-300 mt-5"></div>
      <div className="flow-root">
        {/* Añadir un contenedor con scroll */}
        <div className="overflow-x-auto max-h-[60vh]">
          <div className="inline-block min-w-full align-middle">
            {optionsFestivos.length === 0 ? (
              <Empty onClick={openModal} texto={t("calendar.no_holidays")} />
            ) : (
              <Fragment>
                <table className="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("lesson.views.festivos")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("lesson.views.date")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("lesson.views.time_init")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("lesson.views.time_end")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("lesson.views.type")}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {optionsFestivos.map((holiday) => (
                      <tr key={holiday.id}>
                        <ColumnText title={holiday.description} />
                        <ColumnDate date={holiday.date} />
                        <ColumnText
                          title={
                            holiday.timeStart
                              ? DateTime.fromFormat(
                                  holiday.timeStart,
                                  "hh:mm:ss"
                                ).toFormat("hh:mm a")
                              : ""
                          }
                        />
                        <ColumnText
                          title={
                            holiday.timeEnd
                              ? DateTime.fromFormat(
                                  holiday.timeEnd,
                                  "hh:mm:ss"
                                ).toFormat("hh:mm a")
                              : ""
                          }
                        />
                        <ColumnText title={holiday.type} />
                        <td className="relative whitespace-nowrap py-5 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                          <a
                            onClick={() => onEdit(holiday)}
                            href="#"
                            className="text-primary-600 hover:text-primary-900 mr-4"
                          >
                            {t("general.edit")}
                            <span className="sr-only"></span>
                          </a>
                          <a
                            onClick={() => onDelete(holiday)}
                            href="#"
                            className="text-red-600 hover:text-red-900 mr-4"
                          >
                            <FontAwesomeIcon icon={faTrashCan} />
                            <span className="sr-only"></span>
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableListFestivos;
